<template>
    <div class="faq-page">
        <HeaderLanding mode="light" />
        
            <section class="faq-section">
                <div class="faq-container">
                    <!-- Badge -->
                    <div class="icon-faq">
                        <div class="faq-badge">
                            <img src="@/assets/img/codepen.png" alt="codepen" class="icon" />
                            <span class="label">FAQs</span>
                        </div>
                        <h2 class="faq-title">Frequently Asked<br />Questions</h2>
                    </div>
                </div>
                <div class="faq-description">
                    <p class="description-text">Sagittis aliquam quis nullam in augue porta convallis. Vestibulum senectus facilisi pulvinar suspendisse. <br class="desktop-break"/>Viverra ultrices eu commodo nullam diam ut vel diam egestas</p>
                </div>
            </section>


            <section class="faq-content">
                <div class="faq-filter">
                    <h3 class="label">Filter by Topics</h3>

                    <div class="box-selected">
                        <h4 class="faq active">General</h4>
                        <h4 class="faq">Feature</h4>
                        <h4 class="faq">Billing</h4>
                    </div>
                </div>


                <div class="faq-questions">

                    <div class="faq-general">
                        <h2 class="title-section">General</h2>

                        <div class="qbox" :class="{ active: isActive(0) }" @click="toggleBox(0)">
                            <h3 class="qtitle">What is SurPriz.ing?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(0) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                            <p v-if="isActive(0)" class="qtext">SurPriz.ing is an AI-powered loyalty and feedback platform that helps small businesses collect customer <br/>feedback through QR codes and reward them with digital e-vouchers or collect points — all without<br/> requiring a mobile app.</p>
                        </div>

                        <div class="qbox" :class="{ active: isActive(1) }" @click="toggleBox(1)">
                            <h3 class="qtitle">Who is SurPriz.ing designed for?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(1) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(2) }" @click="toggleBox(2)">
                            <h3 class="qtitle">How does SurPriz.ing work?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(2) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>
                        </div>

                        <div class="faq-component">
                        <h2 class="title-section">Components</h2>

                        <div class="qbox" :class="{ active: isActive(3) }" @click="toggleBox(3)">
                            <h3 class="qtitle">What features are included in SurPriz.ing?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(3) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(4) }" @click="toggleBox(4)">
                            <h3 class="qtitle">Can I customize rewards for different campaigns?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(4) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(5) }" @click="toggleBox(5)">
                            <h3 class="qtitle">How are points collected?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(5) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(6) }" @click="toggleBox(6)">
                            <h3 class="qtitle">Can feedback be made public?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(6) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(7) }" @click="toggleBox(7)">
                            <h3 class="qtitle">Is SurPriz.ing mobile-friendly?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(7) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(8) }" @click="toggleBox(8)">
                            <h3 class="qtitle">Can SurPriz.ing integrate with my POS or CRM system?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(8) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>
                        </div>

                        <div class="faq-billing">
                        <h2 class="title-section">Billing</h2>

                        <div class="qbox" :class="{ active: isActive(9) }" @click="toggleBox(9)">
                            <h3 class="qtitle">What are the pricing plans?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(9) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(10) }" @click="toggleBox(10)">
                            <h3 class="qtitle">Do you offer a free trial?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(10) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(11) }" @click="toggleBox(11)">
                            <h3 class="qtitle">What payment methods do you accept?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(11) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>

                        <div class="qbox" :class="{ active: isActive(12) }" @click="toggleBox(12)">
                            <h3 class="qtitle">Can I upgrade or downgrade anytime?</h3>
                            <img :src="require(`@/assets/img/chevron-${isActive(12) ? 'up' : 'down'}.png`)" class="chevron-icon" alt="toggle chevron" />
                        </div>
                        </div>
                    </div>
            </section>
            <FooterLanding />
        </div>
</template>


<script>
import HeaderLanding from '@/components/HeaderLanding.vue';
import FooterLanding from '@/components/FooterLanding.vue';

export default {
    name: 'AboutUs',
    components: {
        HeaderLanding,
        FooterLanding,
    },
  data() {
    return {
      activeIndexes: [],
    };
  },
  methods: {
    toggleBox(index) {
      if (this.activeIndexes.includes(index)) {
        this.activeIndexes = this.activeIndexes.filter(i => i !== index);
      } else {
        this.activeIndexes.push(index);
      }
    },
    isActive(index) {
      return this.activeIndexes.includes(index);
    }
  }
};
</script>




<style scoped>

.faq-page {
    background-color: #FFFFFF;
    box-sizing: border-box;
    min-height: 100vh;
    overflow-x: hidden;
    font-family: 'Inter', sans-serif;
}

.faq-section {
    background-color: #FFFFFF; /* full width white */
    padding: 96px 120px;
    text-align: center;
}
.faq-container {
    gap: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* faq icon, h1, p */
.icon-faq {
  flex: 1;
  min-width: 280px;
    justify-items: center;
}

.faq-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #FFFFFF;
  border: 1px solid #dfe1e6;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
  font-size: 14px;
  font-weight: 500;
  color: #808897;
  width: fit-content;
  margin-bottom: 16px;
}

.faq-badge .icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.faq-title {
  font-size: 48px;
  font-weight: 500;
  color: #111827;
  line-height: 120%;
}

/* faq content */
.faq-content {
    display: flex;
  max-width: 1160px;
  width: 100%;
  margin: 20px auto;
  font-family: 'Inter', sans-serif;
  color: #1D2939;
  padding: 24px;
}


/* faq filter */
.faq-filter {
  min-width: 230px;
    margin-right: 80px;
}

.faq-filter .label {
  color: #A4ABB8;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 1rem;
}

.box-selected h4.faq {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #808897;
  cursor: pointer;
  transition: all 0.2s ease;
}

.box-selected h4.faq:hover {
  background-color: #DFE1E6;
}

.box-selected h4.faq.active {
  color: #000000;
  border: 1px solid #DFE1E6;
  background-color: #FFFFFF;
  font-weight: 600;
}


/* faq questions */
.faq-questions {
  display: flex;
  flex-direction: column;
  gap: 40px;
    width: 850px;
    padding-bottom: 80px;
    width: min(850px, 100%);
}

/* faq general */
.faq-general {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.faq-general .title-section {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
}
.qbox {
  border: 1px solid #e2e8f0;
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  transition: all 0.3s ease;
}

/* .qbox:hover {
  background-color: #f9fafb;
} */

.qtitle {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.qtext {
    margin-top: 16px;
  font-size: 16px;
    font-weight: 400;
  color: #4a5568;
  line-height: 1.5;
}

.chevron-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 1rem;
  top: 1rem;
  transition: transform 0.3s ease;
}

/* Optional: Rotate icon if you want animation too */
/* .qbox.active .chevron-icon {
  transform: rotate(180deg);
} */

.title-section {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #2d3748;
}


/* faq components */
.faq-component {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.faq-component .title-section {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
}

/* faq billing */
.faq-billing {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.faq-billing .title-section {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
}

.desktop-break {
    display: inline;
}

@media (max-width: 768px) {

  .desktop-break {
    display: none;
  }

  .qbox {
    padding: 16px 20px;
  }

  .plus-icon {
    top: 16px;
    right: 20px;
  }
  .faq-title { font-size: 28px; font-weight: 600; }
  .faq-section { padding: 48px 24px; }
  .description-text { font-size: 12px; line-height: 1.5; margin-top: 16px; }

  .faq-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 100%;
    margin: 0 auto;
    padding: 15px;
  }

  /* 2 columns: [label] | [pills column] */
  .faq-filter {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: start;
    column-gap: 12px;
    row-gap: 8px;
    width: 100%;
    padding: 12px 20px;
  }

  .faq-filter .label {
    font-size: 14px;
    margin: 0;
  }

  .faq-filter .box-selected {
    display: flex;
    flex-direction: column;  /* stack the pills */
    gap: 10px;
    width: 100%;
  }

  .faq-filter .box-selected h4.faq {
    width: 100%;
    text-align: left;
    margin: 0;
    padding: 15px;
  }

  .faq-questions{ width:100%; padding-bottom:48px; gap: 40px; }

  .faq-general .title-section,
  .faq-component .title-section,
  .faq-billing .title-section{ font-size:20px; }

  .qbox{ padding:16px 20px; }
}

</style>